<template>
  <div class="menu">
    <button
      class="menu-item"
      v-if="hasSetDayOff"
      type="button"
      v-on:click="dispatchSetDayOff"
    >Отменить рабочий день</button>
    <button
      class="menu-item"
      type="button"
      v-if="hasViewCabinet"
      v-on:click="dispatchOpenCabinet"
    >Перейти к креслу</button>
  </div>
</template>

<script>
import { builtInPopoverMixin } from '@/mixins/builtInPopoverMixin';

export default {
  computed: {
    hasViewCabinet() {
      return this.actions.includes('view-cabinet');
    },
    hasSetDayOff() {
      return this.actions.includes('set-day-off');
    },
  },
  methods: {
    /**
     * @description Послать событие открытия кабинета.
     * @returns {void}
     */
    dispatchOpenCabinet() {
      this.$emit('open-cabinet', this.cabinetId);
      this.closePopover();
    },
    /**
     * @description Послать событие установки выходного дня.
     * @returns {void}
     */
    dispatchSetDayOff() {
      this.$emit('set-day-off', this.cabinetId, this.day);
      this.closePopover();
    },
  },
  mixins: [builtInPopoverMixin],
  name: 'MenuCabinetAction',
  props: {
    /**
     * @description Допустимые действия.
     * @type {string[]}
     */
    actions: { required: true, type: Array },
    /**
     * @description Идентификатор кабинета.
     * @type {number}
     */
    cabinetId: { required: true, type: Number },
    /**
     * @description Дата в формате ISO.
     * @type {string}
     */
    day: { required: true, type: String },
  },
};
</script>

<style lang="scss">
.menu {
  display: flex;
  flex-direction: column;
  padding: 15px 20px;
  gap: 5px;
  &-item {
    padding: 5px;
    text-align: left;
    transition: .1s color;
    &:hover {
      color: var(--action-color);
    }
  }
}
</style>
